module.exports = __webpack_public_path__ + "static/img/rong5.906f3e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rong5.jpg
// module id = CNBS
// module chunks = 52